class Supplier {
  constructor({ _id, name }) {
    this.id = _id;
    this.name = name;
  }
}
export default Supplier;
